import React, { FunctionComponent, useContext, useEffect, useCallback } from 'react';
import PostcodeCheckContainer from '../../../../common/components/postcodeCheck/PostcodeCheckContainer';
import { PostCodeContext } from '../../../../common/react/PostCodeContext';
import useConfigureActions from '../../../react/customiseData/useConfigureActions';
import useLoadInitialCar from '../../../react/customiseData/useLoadInitialCar';

const RefreshPostcodeCheckContainer: FunctionComponent = () => {
  const { needsRefresh, openModal, isModalOpen, disableRefresh } = useContext(PostCodeContext);
  const { configureBasket } = useConfigureActions();
  const { loadCar } = useLoadInitialCar(configureBasket, true);

  useEffect(() => {
    if (!isModalOpen && needsRefresh === true) {
      openModal(true);
    }
  }, [isModalOpen, needsRefresh, openModal]);

  const triggerBasketInit = useCallback(() => {
    loadCar();
    disableRefresh();
  }, []);

  const handleDealerSelectionCallbacks = [triggerBasketInit];

  if (needsRefresh === false) {
    return null;
  }

  return <PostcodeCheckContainer handleDealerSelectionCallbacks={handleDealerSelectionCallbacks} />;
};

export default RefreshPostcodeCheckContainer;
